export const roles = [
	{ code: "ADMIN", label: "Admin" },
	{ code: "COMUNE", label: "Comune" },
	{ code: "COMUNE_REFERENTE", label: "Comune" },
	{ code: "REGIONE", label: "Regione Toscana" },
	{ code: "LIBRERIA", label: "Libreria" },
	{ code: "CITTADINO", label: "Cittadino" }
];

export const rolesCodes = {
	admin: "ADMIN",
	comune: "COMUNE",
	comuneReferente: "COMUNE_REFERENTE",
	regione: "REGIONE",
	libreria: "LIBRERIA",
	cittadino: "CITTADINO"
}

export const getRoleLabel = (role) => {
	return (roles.find(x => x.code === role)?.label);
}
